;(function (window) {
  
 var $ = window.jQuery;
  var Self = window.leadership = {};
  Self.$document = $(document);
  Self.$document.ready(function () {
    init();
  });

  function init () {

    Self.$leaderCards = $('.c-leadership--card')
    // Self.$leaderNav = $('.js-leadership-nav')
    Self.$leaderCards.on('click',Self.toggleCard)
    // Self.$leaderNav.on('click',Self.toggleNav)
  }

  Self.toggleCard = function(){
    Self.$leaderCards.each(function(){
      // if($(this).hasClass('js-leadership-card-open'))
      // {
      //   $(this).toggleClass('js-leadership-card-open')
      //   $(this).toggleClass('js-leadership-card-closed')
      // }
    })

    $(this).toggleClass('js-leadership-card-open')
    $(this).toggleClass('js-leadership-card-closed')
  }

  Self.toggleNav = function(){

    Self.$leaderNav.each(function(){
        $(this).removeClass('js-inpage-nav--selected')
    })

    $(this).addClass('js-inpage-nav--selected')
  }

})(window)